import { Container, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import NavBar from "../../component/NavBar";
import DocumentLists from "./DocumentLists";
import HttpClient from "../../api/HttpClient";
import { useLoading } from "../../constant/LoadingContext";
import { useLocation, useNavigate } from "react-router-dom";
import DocumentTemplate from "./DocTemplate";
import { useForm, useWatch } from "react-hook-form";
import { z } from "zod";
import ModalContainer from "../../component/ModalContainer";  
import { useGlobalData } from "../../constant/GlobalDataContext";

const docSignatureSchema = z.object({
  signature: z.string(),
  signatureDate: z.date(),
});

const docSignFormSchema = z.object({
  id: z.string(),
  docSignature: z.record(docSignatureSchema),
});
type DocSignForm = z.infer<typeof docSignFormSchema>;

const UnsignDocument = () => {
  const classes = useStyles();
  const [docLists, setDocLists] = useState([]);
  const [showStatus, setShowStatus] = useState<"list" | "document">("list");
  const [docContent, setDocContent] = useState(null);
  const [openSignModal, setOpenSignModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [allSigned, setAllSigned] = useState(false);
  const { setLoading } = useLoading();
  const { globalData } = useGlobalData();
  const location = useLocation();
  const navigate = useNavigate();
  const _searchValue =
    location?.state?.searchValue || globalData?.searchValue || localStorage.getItem("searchValue");

  const useFormReturn = useForm<DocSignForm>({
    defaultValues: {
      id: _searchValue,
      docSignature: {},
    },
  });

  const { register, handleSubmit, formState, setValue } = useFormReturn;
  const docSignatureWatch = useWatch({
    name: "docSignature",
    control: useFormReturn.control,
  });

  useEffect(() => {
    if (docLists.length > 0) {
      let isAllSigned = true;
      docLists.forEach((doc) => {
        if (!docSignatureWatch[doc?.documentName]?.signature) {
          isAllSigned = false;
        }
      });
     
      setAllSigned(isAllSigned);
    }
  }, [docSignatureWatch, docLists]);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  useEffect(() => {
    if(!_searchValue || _searchValue === null) {
      navigate("/p/main/");
      return
    }

    const FetchDocLists = async () => {
      HttpClient().FetchDocListsApi(
        {
          searchValue: _searchValue,
          userDataFilter: user?.data?.userDataFilter,
        },
        (data) => {
          if(data?.data?.filter(o=>o?.signature).length === data?.data?.length) {
            navigate("/p/main/");
          }
          setDocLists(data?.data);
          setLoading(false);
        },
        (error) => {
          alert(error);
          setLoading(false);
        }
      );
    };
    if (_searchValue !== undefined || _searchValue !== null) {
      setLoading(true);
      FetchDocLists();
    }
  }, []);

 
  const submitForm = (data: DocSignForm) => {
    HttpClient().CreateDocumentApi(data,(data)=>{
      alert("文件簽署成功");
      navigate("/p/main/");
    },(error)=> {
      alert(error);
    })
  };

  return (
    <Container className={classes.container}>
      <NavBar
        isBack={true}
        goBack={() => {
          if (showStatus === "document") {
            setShowStatus("list");
          } else {
            navigate(-1);
          }
        }}
        isNeedPW={showStatus === "document" ? false : true}
      />
      <div style={{ backgroundColor: "#F0EFF6", minHeight: "90%" }}>
        {docLists.length > 0 && showStatus === "list" && (
          <DocumentLists
            docLists={docLists}
            setDocContent={setDocContent}
            setShowStatus={setShowStatus}
            allSigned={allSigned}
            docSignatureWatch={docSignatureWatch}
            setOpenConfirmModal={setOpenConfirmModal}
            readonly={false}
          />
        )}
        {docContent && showStatus === "document" && (
          <DocumentTemplate
            docContent={docContent}
            brand={docContent?.brand}
            signature={docSignatureWatch[docContent?.documentName]?.signature}
            signatureDate={docSignatureWatch[docContent?.documentName]?.signatureDate}
            confirmCallback={(signature: string) => {
              setShowStatus("list");
              setValue(`docSignature.${docContent?.documentName}`, {
                signature: signature,
                signatureDate: new Date(),
              });
            }}
          />
        )}
      </div>
     
      <ModalContainer
          type={"isNeedPW"}
          setOpen={setOpenConfirmModal}
          open={openConfirmModal}
          goBack={() => {
            //submit form
            setOpenConfirmModal(false);
            handleSubmit(submitForm)();
          }}
        />
    </Container>
  );
};

export default UnsignDocument;

const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh",
    borderRadius: "10rem",
  },
}));
